import {SELECT_ENROLL_TYPE} from '../actionTypes'


export default function (state = null, action) {
    //console.log(action.type);
    //console.log(action.payload);
    switch (action.type) {
        case SELECT_ENROLL_TYPE:
            return action.payload
    }

    return state;
}